import { render } from "./ItemModal.vue?vue&type=template&id=4697ac0e&scoped=true"
import script from "./ItemModal.vue?vue&type=script&lang=js"
export * from "./ItemModal.vue?vue&type=script&lang=js"

import "./ItemModal.vue?vue&type=style&index=0&id=4697ac0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4697ac0e"]])

export default __exports__